import useMeQuery from "./use-me-query";
import { useMessagesSuspenseQuery } from "./use-messages-suspense-query";
import resolveStartOfDay from "@/utils/resolve-start-of-day";

export const useProgramStartDate = () => {
  const { data: user } = useMeQuery();
  const { data: messages } = useMessagesSuspenseQuery({
    fetchParams: {
      query: {
        limit: 1,
        orderBy: "createdAt",
        orderDirection: "asc",
      },
    },
  });

  const firstMessage = messages[0];

  const utcOptions = {
    timezone: "Etc/UTC",
    withoutDateDifference: true,
  } as const;

  const programStartDate = user.meta?.programStart
    ? resolveStartOfDay(new Date(String(user.meta.programStart)), utcOptions)
    : undefined;

  const firstMessageDate = firstMessage?.createdAt
    ? resolveStartOfDay(new Date(firstMessage.createdAt), utcOptions)
    : undefined;

  return {
    programStartDate,
    firstMessageDate,
  };
};
